import React, { createElement, Component, useMemo, useCallback, useRef, useState, forwardRef, useEffect } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { getApiUrl as getApiUrl$1, fetchFromApi } from '@microlink/mql';
export { fetchFromApi } from '@microlink/mql';

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) {
  if (!REACT_ELEMENT_TYPE) {
    REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7;
  }

  var defaultProps = type && type.defaultProps;
  var childrenLength = arguments.length - 3;

  if (!props && childrenLength !== 0) {
    props = {
      children: void 0
    };
  }

  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = new Array(childrenLength);

    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 3];
    }

    props.children = childArray;
  }

  if (props && defaultProps) {
    for (var propName in defaultProps) {
      if (props[propName] === void 0) {
        props[propName] = defaultProps[propName];
      }
    }
  } else if (!props) {
    props = defaultProps || {};
  }

  return {
    $$typeof: REACT_ELEMENT_TYPE,
    type: type,
    key: key === undefined ? null : '' + key,
    ref: null,
    props: props,
    _owner: null
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var reactIs_production_min = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: !0
  });
  var b = "function" === typeof Symbol && Symbol.for,
      c = b ? Symbol.for("react.element") : 60103,
      d = b ? Symbol.for("react.portal") : 60106,
      e = b ? Symbol.for("react.fragment") : 60107,
      f = b ? Symbol.for("react.strict_mode") : 60108,
      g = b ? Symbol.for("react.profiler") : 60114,
      h = b ? Symbol.for("react.provider") : 60109,
      k = b ? Symbol.for("react.context") : 60110,
      l = b ? Symbol.for("react.async_mode") : 60111,
      m = b ? Symbol.for("react.concurrent_mode") : 60111,
      n = b ? Symbol.for("react.forward_ref") : 60112,
      p = b ? Symbol.for("react.suspense") : 60113,
      q = b ? Symbol.for("react.memo") : 60115,
      r = b ? Symbol.for("react.lazy") : 60116;

  function t(a) {
    if ("object" === _typeof(a) && null !== a) {
      var u = a.$$typeof;

      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;

            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case h:
                  return a;

                default:
                  return u;
              }

          }

        case r:
        case q:
        case d:
          return u;
      }
    }
  }

  function v(a) {
    return t(a) === m;
  }

  exports.typeOf = t;
  exports.AsyncMode = l;
  exports.ConcurrentMode = m;
  exports.ContextConsumer = k;
  exports.ContextProvider = h;
  exports.Element = c;
  exports.ForwardRef = n;
  exports.Fragment = e;
  exports.Lazy = r;
  exports.Memo = q;
  exports.Portal = d;
  exports.Profiler = g;
  exports.StrictMode = f;
  exports.Suspense = p;

  exports.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || "object" === _typeof(a) && null !== a && (a.$$typeof === r || a.$$typeof === q || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n);
  };

  exports.isAsyncMode = function (a) {
    return v(a) || t(a) === l;
  };

  exports.isConcurrentMode = v;

  exports.isContextConsumer = function (a) {
    return t(a) === k;
  };

  exports.isContextProvider = function (a) {
    return t(a) === h;
  };

  exports.isElement = function (a) {
    return "object" === _typeof(a) && null !== a && a.$$typeof === c;
  };

  exports.isForwardRef = function (a) {
    return t(a) === n;
  };

  exports.isFragment = function (a) {
    return t(a) === e;
  };

  exports.isLazy = function (a) {
    return t(a) === r;
  };

  exports.isMemo = function (a) {
    return t(a) === q;
  };

  exports.isPortal = function (a) {
    return t(a) === d;
  };

  exports.isProfiler = function (a) {
    return t(a) === g;
  };

  exports.isStrictMode = function (a) {
    return t(a) === f;
  };

  exports.isSuspense = function (a) {
    return t(a) === p;
  };
});
unwrapExports(reactIs_production_min);
var reactIs_development = createCommonjsModule(function (module, exports) {
});
unwrapExports(reactIs_development);
var reactIs = createCommonjsModule(function (module) {
  {
    module.exports = reactIs_production_min;
  }
});
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;
var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }

  shim.isRequired = shim;

  function getShim() {
    return shim;
  } // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.


  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = factoryWithThrowingShims();
  }
});

function objectWithoutProperties(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}

var NanoClamp =
/*@__PURE__*/
function (Component$$1) {
  function NanoClamp(props) {
    Component$$1.call(this, props);
    this.state = {
      noClamp: false,
      text: '.'
    };
    this.element = null;
    this.original = props.text;
    this.lineHeight = 0;
    this.start = 0;
    this.middle = 0;
    this.end = 0;
    this.debounced = this.debounce(this.action);
  }

  if (Component$$1) NanoClamp.__proto__ = Component$$1;
  NanoClamp.prototype = Object.create(Component$$1 && Component$$1.prototype);
  NanoClamp.prototype.constructor = NanoClamp;

  NanoClamp.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('resize', this.debounced);

    if (this.props.text) {
      this.lineHeight = this.element.clientHeight + 1;
      this.clampLines();
    }
  };

  NanoClamp.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.debounced);
  };

  NanoClamp.prototype.debounce = function debounce(func) {
    var this$1 = this;
    var timeout;

    var later = function later() {
      timeout = null;
      func.apply(this$1);
    };

    return function () {
      var callNow = !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, this$1.props.debounce);

      if (callNow) {
        func.apply(this$1);
      }
    };
  };

  NanoClamp.prototype.action = function action() {
    if (this.original) {
      this.setState({
        noClamp: false
      }, this.clampLines);
    }
  };

  NanoClamp.prototype.clampLines = function clampLines() {
    var this$1 = this;
    var ref = this.props;
    var ellipsis = ref.ellipsis;
    var lines = ref.lines;
    var maxHeight = this.lineHeight * lines + 1;
    var ellipsisLength = ellipsis === NanoClamp.defaultProps.ellipsis ? 5 : ellipsis.length * 1.2;
    this.start = 0;
    this.middle = 0;
    this.end = this.original.length;

    while (this.start <= this.end) {
      this.middle = Math.floor((this.start + this.end) / 2);
      this.element.innerText = this.original.slice(0, this.middle);

      if (this.middle === this.original.length) {
        this.setState({
          text: this.original,
          noClamp: true
        });
        return;
      }

      this.moveMarkers(maxHeight);
    }

    var text = this.original.slice(0, Math.max(this.middle - ellipsisLength, 0)).trim() + ellipsis;
    this.setState({
      text: text
    }, function () {
      this$1.element.innerText = this$1.state.text;
    });
  };

  NanoClamp.prototype.moveMarkers = function moveMarkers(maxHeight) {
    if (this.element.clientHeight <= maxHeight) {
      this.start = this.middle + 1;
    } else {
      this.end = this.middle - 1;
    }
  };

  NanoClamp.prototype.render = function render() {
    var this$1 = this;
    var ref = this.state;
    var text = ref.text;
    var ref$1 = this.props;
    var accessibility = ref$1.accessibility;
    var is = ref$1.is;
    var propText = ref$1.text;
    var rest = objectWithoutProperties(ref$1, ["accessibility", "is", "text", "lines", "debounce", "ellipsis"]);
    var props = rest;
    var clampProps = Object.assign({}, {
      ref: function ref(node) {
        return this$1.element = node;
      }
    }, accessibility ? {
      title: propText
    } : {}, props);
    return propText ? createElement(is, clampProps, text) : null;
  };

  return NanoClamp;
}(Component);

NanoClamp.defaultProps = {
  accessibility: true,
  is: 'div',
  lines: 3,
  ellipsis: '…',
  debounce: 300
};
NanoClamp.propTypes = {
  accessibility: propTypes.bool,
  is: propTypes.string,
  lines: propTypes.number,
  debounce: propTypes.number,
  text: propTypes.string.isRequired,
  ellipsis: propTypes.string
};

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    @media (min-width: 48em) {\n      ", ";\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    @media (max-width: 48em) {\n      ", ";\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var REGEX_LOCALHOST = /http:\/\/localhost/;
var isSSR = typeof window === 'undefined';
var castArray = function castArray(value) {
  return [].concat(value);
};
var getPreferredMedia = function getPreferredMedia(data, mediaProps) {
  var prefer;

  for (var index = 0; index < mediaProps.length; index++) {
    var key = mediaProps[index];
    var value = data[key];

    if (!isNil(value)) {
      prefer = key;
      break;
    }
  }

  return prefer;
};
var isFunction = function isFunction(fn) {
  return typeof fn === 'function';
};
var isObject = function isObject(obj) {
  return _typeof(obj) === 'object';
};
var isNil = function isNil(value) {
  return value == null;
};
var getUrlPath = function getUrlPath(data) {
  return isObject(data) ? data.url : data;
};
var someProp = function someProp(data, props) {
  return data[props.find(function (prop) {
    return !isNil(data[prop]);
  })];
};
var media = {
  mobile: function mobile() {
    return css(_templateObject(), css.apply(void 0, arguments));
  },
  desktop: function desktop() {
    return css(_templateObject2(), css.apply(void 0, arguments));
  }
};
var getApiUrl = function getApiUrl(_ref) {
  var apiKey = _ref.apiKey,
      _ref$contrast = _ref.contrast,
      contrast = _ref$contrast === void 0 ? false : _ref$contrast,
      data = _ref.data,
      force = _ref.force,
      headers = _ref.headers,
      media = _ref.media,
      prerender = _ref.prerender,
      proxy = _ref.proxy,
      ttl = _ref.ttl,
      url = _ref.url;
  return getApiUrl$1(url, {
    apiKey: apiKey,
    audio: media.includes('audio'),
    data: data,
    force: force,
    headers: headers,
    iframe: media.includes('iframe'),
    palette: contrast,
    prerender: prerender,
    proxy: proxy,
    screenshot: media.includes('screenshot'),
    ttl: ttl,
    video: media.includes('video')
  });
};
var isLarge = function isLarge(cardSize) {
  return cardSize === 'large';
};
var isSmall = function isSmall(cardSize) {
  return cardSize === 'small';
};
var imageProxy = function imageProxy(url) {
  return REGEX_LOCALHOST.test(url) ? url : "https://images.weserv.nl/?url=".concat(encodeURIComponent(url), "&l=9&af&il&n=-1");
};
var isLazySupported = !isSSR && 'IntersectionObserver' in window;
var BASE_CLASSNAME = 'microlink_card';
var CONTENT_BASE_CLASSNAME = "".concat(BASE_CLASSNAME, "__content");
var MEDIA_BASE_CLASSNAME = "".concat(BASE_CLASSNAME, "__media");
var CONTROLS_BASE_CLASSNAME = "".concat(MEDIA_BASE_CLASSNAME, "__controls");
var classNames = {
  main: BASE_CLASSNAME,
  content: CONTENT_BASE_CLASSNAME,
  title: "".concat(CONTENT_BASE_CLASSNAME, "_title"),
  description: "".concat(CONTENT_BASE_CLASSNAME, "_description"),
  url: "".concat(CONTENT_BASE_CLASSNAME, "_url"),
  mediaWrapper: "".concat(MEDIA_BASE_CLASSNAME, "_wrapper"),
  media: MEDIA_BASE_CLASSNAME,
  image: "".concat(MEDIA_BASE_CLASSNAME, "_image"),
  videoWrapper: "".concat(MEDIA_BASE_CLASSNAME, "_video_wrapper"),
  video: "".concat(MEDIA_BASE_CLASSNAME, "_video"),
  audioWrapper: "".concat(MEDIA_BASE_CLASSNAME, "_audio_wrapper"),
  audio: "".concat(MEDIA_BASE_CLASSNAME, "_audio"),
  mediaControls: CONTROLS_BASE_CLASSNAME,
  playbackControl: "".concat(CONTROLS_BASE_CLASSNAME, "_playback"),
  volumeControl: "".concat(CONTROLS_BASE_CLASSNAME, "_volume"),
  rwControl: "".concat(CONTROLS_BASE_CLASSNAME, "_rewind"),
  ffwControl: "".concat(CONTROLS_BASE_CLASSNAME, "_fast_forward"),
  rateControl: "".concat(CONTROLS_BASE_CLASSNAME, "_rate"),
  progressBar: "".concat(CONTROLS_BASE_CLASSNAME, "_progress"),
  progressTime: "".concat(CONTROLS_BASE_CLASSNAME, "_progress_time"),
  iframe: "".concat(BASE_CLASSNAME, "__iframe")
};

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n    "]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  &&& {\n    text-align: inherit;\n    font-weight: inherit;\n    font-family: inherit;\n    color: inherit;\n    margin: 0;\n\n    ", "\n  }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var Clamp = function Clamp(_ref) {
  var children = _ref.children,
      className = _ref.className,
      lines = _ref.lines;
  return isNil(children) ? null : _jsx(NanoClamp, {
    className: className,
    lines: lines,
    text: children,
    is: "p"
  });
};

var StyledClamp = styled(Clamp)(_templateObject$1(), function (_ref2) {
  var useNanoClamp = _ref2.useNanoClamp;
  return !useNanoClamp && css(_templateObject2$1());
});

var CardText = function CardText(_ref3) {
  var _ref3$useNanoClamp = _ref3.useNanoClamp,
      useNanoClamp = _ref3$useNanoClamp === void 0 ? true : _ref3$useNanoClamp,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["useNanoClamp", "children"]);

  var textProps = useNanoClamp ? props : _objectSpread2({}, props, {
    as: 'p',
    title: children
  });
  return React.createElement(StyledClamp, _extends({
    useNanoClamp: useNanoClamp
  }, textProps), children);
};

var speed = {
  short: '100ms',
  medium: '150ms',
  long: '300ms'
};
var animation = {
  short: 'cubic-bezier(.25,.8,.25,1)',
  medium: 'cubic-bezier(.25,.8,.25,1)',
  long: 'cubic-bezier(.4, 0, .2, 1)'
};
var transition = {
  short: "".concat(speed.short, " ").concat(animation.short),
  medium: "".concat(speed.medium, " ").concat(animation.medium),
  long: "".concat(speed.long, " ").concat(animation.long)
}; // https://primer.style/design/foundations/typography

var font = {
  sans: "InterUI, -apple-system, BlinkMacSystemFont, 'Helvetica Neue', 'Segoe UI', Oxygen, Ubuntu, Cantarell, 'Open Sans', sans-serif",
  mono: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace"
};

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  background: url('https://cdn.microlink.io/logo/logo.svg') no-repeat center\n    center;\n  display: block;\n  margin-left: 15px;\n  transition: filter ", ", opacity ", ";\n  &:not(:hover) {\n    filter: grayscale(100%);\n    opacity: 0.75;\n  }\n\n  min-width: ", ";\n  width: ", ";\n  background-size: ", ";\n  height: ", ";\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  opacity: 0.75;\n  transition: opacity ", ";\n\n  .", ":hover & {\n    opacity: 1;\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    font-size: ", ";\n    ", "\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  text-align: left;\n  margin: 0;\n  flex-grow: 0;\n  ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  text-align: left;\n  font-size: 14px;\n  flex-grow: 2;\n  margin: auto 0;\n  line-height: 18px;\n  ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        min-width: 0;\n        padding-right: 14px;\n      "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    flex-grow: ", ";\n    font-size: ", ";\n\n    ", "\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  text-align: left;\n  font-weight: bold;\n  margin: 0;\n  width: 100%;\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    flex: ", ";\n    justify-content: ", ";\n    flex-direction: ", ";\n    align-items: ", ";\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 10px 15px;\n  min-width: 0;\n  box-sizing: border-box;\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteral(["\n    > p {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  "]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var REGEX_STRIP_WWW = /^www\./;
var BADGE_WIDTH = '16px';
var BADGE_HEIGHT = '12px';

var getHostname = function getHostname(href) {
  if (isNil(href)) return '';

  var _ref = new URL(href),
      hostname = _ref.hostname;

  return hostname.replace(REGEX_STRIP_WWW, '');
};

var mobileDescriptionStyle = css(_templateObject$2(), media.mobile(_templateObject2$2()));
var Content = styled('div').attrs({
  className: classNames.content
})(_templateObject3(), function (_ref2) {
  var cardSize = _ref2.cardSize;
  return css(_templateObject4(), !isLarge(cardSize) ? 1 : '0 0 125px', !isSmall(cardSize) ? 'space-around' : 'space-between', !isSmall(cardSize) ? 'column' : 'row', !isSmall(cardSize) ? 'stretch' : 'center');
});
var Header = styled('header').attrs({
  className: classNames.title
})(_templateObject5(), function (_ref3) {
  var cardSize = _ref3.cardSize;
  return css(_templateObject6(), !isSmall(cardSize) ? 1.2 : 0.8, !isSmall(cardSize) ? '16px' : '15px', isSmall(cardSize) && css(_templateObject7()));
});
var Description = styled('div').attrs({
  className: classNames.description
})(_templateObject8(), function (_ref4) {
  var cardSize = _ref4.cardSize;
  return !isLarge(cardSize) && mobileDescriptionStyle;
});
var Footer = styled('footer').attrs({
  className: classNames.url
})(_templateObject9(), function (_ref5) {
  var cardSize = _ref5.cardSize;
  return css(_templateObject10(), !isSmall(cardSize) ? '12px' : '10px', !isSmall(cardSize) && 'width: 100%;');
});
var Author = styled(CardText)(_templateObject11(), transition.medium, classNames.main);
var PoweredBy = styled('span').attrs({
  title: 'microlink.io'
})(_templateObject12(), transition.medium, transition.medium, BADGE_WIDTH, BADGE_WIDTH, BADGE_WIDTH, BADGE_HEIGHT);
var CardContent = (function (_ref6) {
  var title = _ref6.title,
      description = _ref6.description,
      url = _ref6.url,
      cardSize = _ref6.cardSize;
  var isSmallCard = isSmall(cardSize);
  var formattedUrl = useMemo(function () {
    return getHostname(url);
  }, [url]);
  var handleOnClick = useCallback(function (e) {
    e.preventDefault();
    window.open('https://www.microlink.io', '_blank');
  });
  return _jsx(Content, {
    cardSize: cardSize
  }, void 0, _jsx(Header, {
    cardSize: cardSize
  }, void 0, _jsx(CardText, {
    useNanoClamp: false
  }, void 0, title)), !isSmallCard && _jsx(Description, {
    cardSize: cardSize
  }, void 0, _jsx(CardText, {
    lines: 2
  }, void 0, description)), _jsx(Footer, {
    cardSize: cardSize
  }, void 0, _jsx(Author, {
    useNanoClamp: false
  }, void 0, formattedUrl), _jsx(PoweredBy, {
    onClick: handleOnClick
  })));
});

function _templateObject4$1() {
  var data = _taggedTemplateLiteral(["\n  animation: ", " 1.25s linear infinite;\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteral(["\n  animation: ", " .75s linear infinite;\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$3() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    background: #e1e8ed;\n  }\n  70% {\n    background: #dce3e8;\n  }\n  100% {\n    background: #e1e8ed;\n  }\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    background: #e1e8ed;\n  }\n  70% {\n    background: #cdd4d8;\n  }\n  100% {\n    background: #e1e8ed;\n  }\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var emptyStatePulse = keyframes(_templateObject$3());
var emptyStateImagePulse = keyframes(_templateObject2$3());
var emptyStateAnimation = css(_templateObject3$1(), emptyStatePulse);
var emptyStateImageAnimation = css(_templateObject4$1(), emptyStateImagePulse);

function _templateObject2$4() {
  var data = _taggedTemplateLiteral(["\n  &::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    background: #e1e8ed;\n    opacity: ", ";\n    z-index: 1;\n  }\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n  height: 1px;\n  width: 1px;\n  position: absolute;\n  z-index: -1;\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var ImageLoadCatcher = styled('img')(_templateObject$4());
var loadingOverlay = css(_templateObject2$4(), function (_ref) {
  var loading = _ref.loading;
  return loading ? 1 : 0;
});

function _templateObject5$1() {
  var data = _taggedTemplateLiteral(["\n  background: transparent no-repeat center center / cover;\n  display: block;\n  overflow: hidden;\n  height: auto;\n  position: relative;\n\n  &::before {\n    content: '';\n    padding-bottom: 100%;\n    display: block;\n  }\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$2() {
  var data = _taggedTemplateLiteral(["\n    flex: 1;\n\n    &::before {\n      padding-bottom: 0;\n    }\n  "]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteral(["\n      flex: 0 0 92px;\n    "]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$5() {
  var data = _taggedTemplateLiteral(["\n    flex: 0 0 125px;\n\n    ", "\n  "]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n    flex: 0 0 48px;\n  "]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
var mediaSizeStyles = {
  small: css(_templateObject$5()),
  normal: css(_templateObject2$5(), media.mobile(_templateObject3$2())),
  large: css(_templateObject4$2())
};
var Wrap = styled('div')(_templateObject5$1(), function (_ref) {
  var cardSize = _ref.cardSize;
  return mediaSizeStyles[cardSize];
}, loadingOverlay);

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n  background-image: ", ";\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}
var Image = styled(Wrap).attrs({
  className: "".concat(classNames.media, " ").concat(classNames.image)
})(_templateObject$6(), function (_ref) {
  var imageUrl = _ref.imageUrl;
  return imageUrl ? "url('".concat(imageProxy(imageUrl), "')") : '';
});

function _templateObject5$2() {
  var data = _taggedTemplateLiteral(["\n  height: 10px;\n  width: 30%;\n  display: block;\n  background: #e1e8ed;\n  opacity: 0.8;\n  ", " animation-delay: .25s;\n"]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$3() {
  var data = _taggedTemplateLiteral(["\n    height: 14px;\n\n    &::before {\n      display: none;\n    }\n  "]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$3() {
  var data = _taggedTemplateLiteral(["\n  height: 33px;\n  width: 95%;\n  display: block;\n  background: #e1e8ed;\n  margin-bottom: 12px;\n  opacity: 0.8;\n  position: relative;\n  ", ";\n  animation-delay: 0.125s;\n\n  &::before {\n    content: '';\n    position: absolute;\n    left: -1px;\n    right: -1px;\n    height: 6px;\n    background: #fff;\n  }\n\n  &::before {\n    top: 14px;\n  }\n\n  ", ";\n"]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$6() {
  var data = _taggedTemplateLiteral(["\n  height: 16px;\n  width: ", ";\n  display: block;\n  background: #e1e8ed;\n  margin: ", ";\n  opacity: 0.8;\n  ", ";\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$7() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}
var MediaEmpty = styled(Image)(_templateObject$7(), emptyStateImageAnimation);
var HeaderEmpty = styled('span')(_templateObject2$6(), function (_ref) {
  var cardSize = _ref.cardSize;
  return !isSmall(cardSize) ? '60%' : '75%';
}, function (_ref2) {
  var cardSize = _ref2.cardSize;
  return !isSmall(cardSize) ? '2px 0 8px' : '0 20px 0 0';
}, emptyStateAnimation);
var DescriptionEmpty = styled('span')(_templateObject3$3(), emptyStateAnimation, function (_ref3) {
  var cardSize = _ref3.cardSize;
  return !isLarge(cardSize) && media.mobile(_templateObject4$3());
});
var FooterEmpty = styled('span')(_templateObject5$2(), emptyStateAnimation);

var _ref5 =
/*#__PURE__*/
_jsx(FooterEmpty, {});

var CardEmptyState = function CardEmptyState(_ref4) {
  var cardSize = _ref4.cardSize;
  var isSmallCard = isSmall(cardSize);
  return React.createElement(React.Fragment, null, _jsx(MediaEmpty, {
    cardSize: cardSize
  }), _jsx(Content, {
    cardSize: cardSize
  }, void 0, _jsx(HeaderEmpty, {
    cardSize: cardSize
  }), !isSmallCard && _jsx(DescriptionEmpty, {
    cardSize: cardSize
  }), _ref5));
};

function _templateObject$8() {
  var data = _taggedTemplateLiteral(["\n  backface-visibility: hidden;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));\n  transition: transform ", ";\n\n  > svg {\n    display: block;\n  }\n\n  &:active:not(:focus) {\n    transform: scale(0.9);\n  }\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}
var MediaButton = styled('div')(_templateObject$8(), transition.short);

function _templateObject7$1() {
  var data = _taggedTemplateLiteral(["\n  margin: ", ";\n  font-family: ", ";\n  font-size: 12px;\n  padding: 0 16px;\n  color: #fff;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n"]);

  _templateObject7$1 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$1() {
  var data = _taggedTemplateLiteral(["\n    font-size: 8px;\n    margin-left: 8px;\n    min-width: 23px;\n  "]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$3() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", "px;\n  min-width: ", "px;\n  line-height: 1;\n  font-weight: bold;\n  border: 1.5px solid #fff;\n  border-radius: 9999px;\n  padding: 1px 5px;\n  text-align: center;\n  color: #fff;\n  margin-left: 10px;\n\n  ", "\n"]);

  _templateObject5$3 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$4() {
  var data = _taggedTemplateLiteral(["\n      width: 12px;\n      height: 12px;\n    "]);

  _templateObject4$4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$4() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    width: ", "px;\n    height: ", "px;\n\n    ", "\n  }\n"]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$7() {
  var data = _taggedTemplateLiteral(["\n  stroke: #fff;\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$9() {
  var data = _taggedTemplateLiteral(["\n  z-index: 2;\n  position: absolute;\n  bottom: ", "px;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: opacity ", ";\n\n  .", ":not(:hover) & {\n    opacity: 0;\n  }\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}

var _ref =
/*#__PURE__*/
_jsx("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1",
  d: "M15.5 6.205l-.705-.705L13 7.295 11.205 5.5l-.705.705L12.295 8 10.5 9.795l.705.705L13 8.705l1.795 1.795.705-.705L13.705 8 15.5 6.205zM9 15a.5.5 0 01-.355-.15L4.835 11H1.5a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h3.335l3.81-3.85a.5.5 0 01.705 0 .5.5 0 01.15.35v13a.5.5 0 01-.5.5z",
  transform: "translate(-1 -1)"
});

var VolumeMute = function VolumeMute(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _ref);
};

var _ref2 =
/*#__PURE__*/
_jsx("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1",
  d: "M13.58 4.04l-.765.645a5 5 0 01-.145 6.615l.735.7a6 6 0 00.175-7.94v-.02zM10.79 6a3 3 0 01-.09 3.97l.735.68a4 4 0 00.115-5.295L10.79 6zM9 15a.5.5 0 01-.355-.15L4.835 11H1.5a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h3.335l3.81-3.85a.5.5 0 01.705 0 .5.5 0 01.15.35v13a.5.5 0 01-.5.5z",
  transform: "translate(-1 -1)"
});

var VolumeUp = function VolumeUp(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _ref2);
};

var BottomControls = styled('div')(_templateObject$9(), function (_ref3) {
  var cardSize = _ref3.cardSize;
  return isLarge(cardSize) ? 12 : 10;
}, transition.medium, classNames.main);
var VolumeIcon = styled('svg')(_templateObject2$7());
var VolumeButton = styled(MediaButton).attrs({
  className: classNames.volumeControl
})(_templateObject3$4(), VolumeIcon, function (_ref4) {
  var cardSize = _ref4.cardSize;
  return isLarge(cardSize) ? 16 : 14;
}, function (_ref5) {
  var cardSize = _ref5.cardSize;
  return isLarge(cardSize) ? 16 : 14;
}, function (_ref6) {
  var cardSize = _ref6.cardSize;
  return !isLarge(cardSize) && media.mobile(_templateObject4$4());
});
var PlaybackRateButton = styled(MediaButton).attrs({
  className: classNames.rateControl
})(_templateObject5$3(), function (_ref7) {
  var cardSize = _ref7.cardSize;
  return isLarge(cardSize) ? 12 : 10;
}, function (_ref8) {
  var cardSize = _ref8.cardSize;
  return isLarge(cardSize) ? 33 : 28;
}, function (_ref9) {
  var cardSize = _ref9.cardSize;
  return !isLarge(cardSize) && media.mobile(_templateObject6$1());
});
var TimeLabel = styled('span').attrs({
  className: classNames.progressTime
})(_templateObject7$1(), function (_ref10) {
  var right = _ref10.right;
  return !right ? '0 auto 0 0' : '0 0 0 auto';
}, font.mono);

var FooterControls = function FooterControls(_ref11) {
  var cardSize = _ref11.cardSize,
      currentTime = _ref11.currentTime,
      endTime = _ref11.endTime,
      isMuted = _ref11.isMuted,
      onMuteClick = _ref11.onMuteClick,
      onPlaybackRateClick = _ref11.onPlaybackRateClick,
      playbackRate = _ref11.playbackRate;
  var VolumeComponent = useMemo(function () {
    return isMuted ? VolumeMute : VolumeUp;
  }, [isMuted]);
  var isLargeCard = useMemo(function () {
    return isLarge(cardSize);
  }, [cardSize]);
  return _jsx(BottomControls, {
    cardSize: cardSize
  }, void 0, isLargeCard && _jsx(TimeLabel, {}, void 0, currentTime), _jsx(VolumeButton, {
    title: isMuted ? 'Unmute' : 'Mute',
    cardSize: cardSize,
    onClick: onMuteClick
  }, void 0, _jsx(VolumeIcon, {
    as: VolumeComponent
  })), _jsx(PlaybackRateButton, {
    title: "Playback Rate",
    cardSize: cardSize,
    onClick: onPlaybackRateClick
  }, void 0, _jsx("span", {}, void 0, playbackRate, "x")), isLargeCard && _jsx(TimeLabel, {
    right: true
  }, void 0, endTime));
};

function _templateObject4$5() {
  var data = _taggedTemplateLiteral(["\n        width: calc(", " * 1.2);\n        height: calc(", " * 1.2);\n      "]);

  _templateObject4$5 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$5() {
  var data = _taggedTemplateLiteral(["\n      width: ", ";\n      height: ", ";\n      padding: ", ";\n\n      ", "\n    "]);

  _templateObject3$5 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$8() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    ", "\n  }\n"]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$a() {
  var data = _taggedTemplateLiteral(["\n  stroke: #fff;\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}

var _ref$1 =
/*#__PURE__*/
_jsx("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1",
  d: "M12 6h-2a2 2 0 00-2 2v16a2 2 0 002 2h2a2 2 0 002-2V8a2 2 0 00-2-2zm10 0h-2a2 2 0 00-2 2v16a2 2 0 002 2h2a2 2 0 002-2V8a2 2 0 00-2-2z",
  transform: "translate(-8 -6)"
});

var Pause = function Pause(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 20"
  }, props), _ref$1);
};

var _ref2$1 =
/*#__PURE__*/
_jsx("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1",
  d: "M7 28a1 1 0 01-1-1V5a1 1 0 011.501-.865l19 11a1 1 0 010 1.73l-19 11A.998.998 0 017 28z",
  transform: "translate(-6 -4)"
});

var Play = function Play(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 24"
  }, props), _ref2$1);
};

var iconSizes = {
  large: '50px',
  normal: '35px',
  small: '20px'
};
var PlaybackIcon = styled('svg')(_templateObject$a());
var PlaybackButtonWrap = styled(MediaButton).attrs({
  className: classNames.playbackControl
})(_templateObject2$8(), PlaybackIcon, function (_ref3) {
  var cardSize = _ref3.cardSize;
  return css(_templateObject3$5(), iconSizes[cardSize], iconSizes[cardSize], isLarge(cardSize) ? 0 : '8px', !isLarge(cardSize) && !isSmall(cardSize) && media.mobile(_templateObject4$5(), iconSizes.small, iconSizes.small));
});

var PlaybackButton = function PlaybackButton(_ref4) {
  var isPlaying = _ref4.isPlaying,
      props = _objectWithoutProperties(_ref4, ["isPlaying"]);

  var PlaybackComponent = useMemo(function () {
    return isPlaying ? Pause : Play;
  }, [isPlaying]);
  return React.createElement(PlaybackButtonWrap, _extends({
    title: isPlaying ? 'Pause' : 'Play'
  }, props), _jsx(PlaybackIcon, {
    as: PlaybackComponent
  }));
};

function _templateObject$b() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  background: #e1e8ed;\n  height: ", "px;\n  transition: opacity ", ", background ", ";\n\n  .", ":hover & {\n    background: #fff;\n  }\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}
var BASE_HEIGHT = 5;
var sizeScales = {
  normal: 0.8,
  small: 0.7
};

var getProgressBarSize = function getProgressBarSize(_ref) {
  var cardSize = _ref.cardSize;
  return BASE_HEIGHT * (sizeScales[cardSize] || 1);
};

var ProgressBar = styled('div').attrs(function (_ref2) {
  var progress = _ref2.progress;
  return {
    className: classNames.progressBar,
    style: {
      width: "".concat(progress, "%") || 0,
      opacity: 0.8
    }
  };
})(_templateObject$b(), function (props) {
  return getProgressBarSize(props);
}, transition.medium, transition.medium, classNames.main);

function _templateObject3$6() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 ", ";\n"]);

  _templateObject3$6 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$9() {
  var data = _taggedTemplateLiteral(["\n    width: 0;\n    height: 0;\n  "]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$c() {
  var data = _taggedTemplateLiteral(["\n  stroke: #fff;\n  width: ", "px;\n  height: ", "px;\n\n  ", "\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}

var _ref2$2 =
/*#__PURE__*/
_jsx("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1",
  d: "M4 18c0 6.627 5.373 12 12 12s12-5.373 12-12S22.627 6 16 6h-4V1L6 7l6 6V8h4c5.523 0 10 4.477 10 10s-4.477 10-10 10S6 23.523 6 18H4zm15.63 4.13a2.84 2.84 0 01-1.28-.27 2.44 2.44 0 01-.89-.77 3.57 3.57 0 01-.52-1.25 7.69 7.69 0 01-.17-1.68 7.83 7.83 0 01.17-1.68c.094-.445.27-.87.52-1.25.23-.325.535-.59.89-.77.4-.188.838-.28 1.28-.27a2.44 2.44 0 012.16 1 5.23 5.23 0 01.7 2.93 5.23 5.23 0 01-.7 2.93 2.44 2.44 0 01-2.16 1.08zm0-1.22c.411.025.8-.19 1-.55a3.38 3.38 0 00.37-1.51v-1.38a3.31 3.31 0 00-.29-1.5 1.23 1.23 0 00-2.06 0 3.31 3.31 0 00-.29 1.5v1.38a3.38 3.38 0 00.29 1.51c.195.356.575.57.98.55zm-9 1.09v-1.18h2v-5.19l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22h-5.15z",
  transform: "translate(-4 -1)"
});

var Backward = function Backward(_ref) {
  var cardSize = _ref.cardSize,
      props = _objectWithoutProperties(_ref, ["cardSize"]);

  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 29"
  }, props), _ref2$2);
};

var _ref4 =
/*#__PURE__*/
_jsx("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1",
  d: "M26 18c0 5.523-4.477 10-10 10S6 23.523 6 18 10.477 8 16 8h4v5l6-6-6-6v5h-4C9.373 6 4 11.373 4 18s5.373 12 12 12 12-5.373 12-12h-2zm-6.36 4.13a2.81 2.81 0 01-1.28-.27 2.36 2.36 0 01-.89-.77 3.39 3.39 0 01-.47-1.25 7.12 7.12 0 01-.17-1.68 7.24 7.24 0 01.17-1.68 3.46 3.46 0 01.52-1.25 2.36 2.36 0 01.89-.77c.4-.19.838-.282 1.28-.27a2.44 2.44 0 012.16 1 5.31 5.31 0 01.7 2.93 5.31 5.31 0 01-.7 2.93 2.44 2.44 0 01-2.21 1.08zm0-1.22a1 1 0 001-.55c.22-.472.323-.99.3-1.51v-1.38a3.17 3.17 0 00-.3-1.5 1.22 1.22 0 00-2.05 0 3.18 3.18 0 00-.29 1.5v1.38a3.25 3.25 0 00.29 1.51 1 1 0 001.05.55zm-7.02-3.49c.355.035.71-.06 1-.27a.84.84 0 00.31-.68v-.08a.94.94 0 00-.3-.74 1.2 1.2 0 00-.83-.27 1.65 1.65 0 00-.89.24 2.1 2.1 0 00-.68.68l-.93-.83a5.37 5.37 0 01.44-.51 2.7 2.7 0 01.54-.4 2.55 2.55 0 01.7-.27 3.25 3.25 0 01.87-.1 3.94 3.94 0 011.06.14c.297.078.576.214.82.4.224.168.408.383.54.63.123.26.184.543.18.83a2 2 0 01-.11.67 1.82 1.82 0 01-.32.52 1.79 1.79 0 01-.47.36 2.27 2.27 0 01-.57.2V18c.219.04.431.11.63.21a1.7 1.7 0 01.85.93c.084.234.124.481.12.73a2 2 0 01-.2.92 2 2 0 01-.58.72 2.66 2.66 0 01-.89.45 3.76 3.76 0 01-1.15.16 4.1 4.1 0 01-1-.11 3.1 3.1 0 01-.76-.31 2.76 2.76 0 01-.56-.45 4.22 4.22 0 01-.44-.55l1.07-.81c.082.147.175.288.28.42.105.128.226.243.36.34.137.097.29.171.45.22a2 2 0 00.57.07 1.45 1.45 0 001-.3 1.12 1.12 0 00.34-.85v-.08a1 1 0 00-.37-.8 1.78 1.78 0 00-1.06-.28h-.76v-1.21h.74z",
  transform: "translate(-4 -1)"
});

var Forward = function Forward(_ref3) {
  var cardSize = _ref3.cardSize,
      props = _objectWithoutProperties(_ref3, ["cardSize"]);

  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 29"
  }, props), _ref4);
};

var SeekIcon = styled('svg')(_templateObject$c(), function (_ref5) {
  var cardSize = _ref5.cardSize;
  return isLarge(cardSize) ? 30 : 24;
}, function (_ref6) {
  var cardSize = _ref6.cardSize;
  return isLarge(cardSize) ? 30 : 24;
}, function (_ref7) {
  var cardSize = _ref7.cardSize;
  return !isLarge(cardSize) && media.mobile(_templateObject2$9());
});
var SeekButtonWrap = styled(MediaButton)(_templateObject3$6(), function (_ref8) {
  var cardSize = _ref8.cardSize;
  return isLarge(cardSize) ? '28px' : '3px';
});

var SeekButton = function SeekButton(_ref9) {
  var _ref9$type = _ref9.type,
      type = _ref9$type === void 0 ? 'rewind' : _ref9$type,
      cardSize = _ref9.cardSize,
      props = _objectWithoutProperties(_ref9, ["type", "cardSize"]);

  var IconComponent = useMemo(function () {
    return type === 'rewind' ? Backward : Forward;
  }, [type]);
  return React.createElement(SeekButtonWrap, _extends({
    title: type === 'rewind' ? 'Rewind' : 'Forward',
    cardSize: cardSize
  }, props), _jsx(SeekIcon, {
    as: IconComponent,
    cardSize: cardSize
  }));
};

function _templateObject2$a() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n  transition: opacity ", ";\n\n  .", ":not(:hover) & {\n    opacity: ", ";\n  }\n"]);

  _templateObject2$a = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$d() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  transition: background ", ";\n\n  .", ":hover & {\n    background: rgba(0, 0, 0, 0.35);\n  }\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}
var OuterWrap = styled('div').attrs({
  className: classNames.mediaControls
})(_templateObject$d(), transition.long, classNames.main);
var InnerWrap = styled('div')(_templateObject2$a(), transition.medium, classNames.main, function (_ref) {
  var _ref$opacity = _ref.opacity,
      opacity = _ref$opacity === void 0 ? 0 : _ref$opacity;
  return opacity;
});

var getNextPlaybackRate = function getNextPlaybackRate(rate) {
  switch (rate) {
    case 1:
      return 1.25;

    case 1.25:
      return 1.5;

    case 1.5:
      return 2;

    default:
      return 1;
  }
};

var formatSeconds = function formatSeconds(secs) {
  var secsToNum = parseInt(secs, 10);
  var hours = Math.floor(secsToNum / 3600);
  var minutes = Math.floor(secsToNum / 60) % 60;
  var seconds = secsToNum % 60;
  return [hours, minutes, seconds].filter(function (v, i) {
    return v > 0 || i > 0;
  }).map(function (v) {
    return v >= 10 ? v : "0".concat(v);
  }).join(':');
};

var Controls = function Controls(_ref2) {
  var autoPlay = _ref2.autoPlay,
      cardSize = _ref2.cardSize,
      loop = _ref2.loop,
      MediaComponent = _ref2.MediaComponent,
      mediaProps = _ref2.mediaProps,
      _ref2$muted = _ref2.muted,
      muted = _ref2$muted === void 0 ? false : _ref2$muted,
      showControls = _ref2.showControls;
  var mediaRef = useRef();

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      duration = _useState2[0],
      setDuration = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      progress = _useState4[0],
      setProgress = _useState4[1];

  var _useState5 = useState(autoPlay),
      _useState6 = _slicedToArray(_useState5, 2),
      isPlaying = _useState6[0],
      setIsPlaying = _useState6[1];

  var _useState7 = useState(muted),
      _useState8 = _slicedToArray(_useState7, 2),
      isMuted = _useState8[0],
      setIsMuted = _useState8[1];

  var _useState9 = useState(1),
      _useState10 = _slicedToArray(_useState9, 2),
      playbackRate = _useState10[0],
      setPlaybackRate = _useState10[1];

  var _useState11 = useState(autoPlay),
      _useState12 = _slicedToArray(_useState11, 2),
      hasInteracted = _useState12[0],
      setHasInteracted = _useState12[1];

  var isNotSmall = useMemo(function () {
    return !isSmall(cardSize);
  }, [cardSize]);
  var setInitialDuration = useCallback(function () {
    if (mediaRef && mediaRef.current) {
      setDuration(mediaRef.current.duration || 0);
    }
  }, [mediaRef.current]);
  var onPlaybackToggle = useCallback(function (event) {
    event.preventDefault();

    if (mediaRef && mediaRef.current) {
      if (mediaRef.current.paused) {
        if (!hasInteracted) {
          setHasInteracted(true);
        }

        mediaRef.current.play();
      } else {
        mediaRef.current.pause();
      }
    }
  }, [mediaRef.current]);
  var onSeekClick = useCallback(function (event, type) {
    event.preventDefault();
    event.stopPropagation();

    if (type === 'rewind') {
      mediaRef.current.currentTime -= 10;
    } else {
      mediaRef.current.currentTime += 30;
    }
  }, [mediaRef.current]);
  var onTimeUpdate = useCallback(function (event) {
    if (mediaRef && mediaRef.current) {
      setProgress(mediaRef.current.currentTime);
    }
  }, [mediaRef.current]);
  var onMuteClick = useCallback(function (event) {
    event.preventDefault();
    event.stopPropagation();

    if (mediaRef && mediaRef.current) {
      mediaRef.current.muted = !isMuted;
      setIsMuted(function (prevState) {
        return !prevState;
      });
    }
  }, [mediaRef.current, isMuted]);
  var onPlaybackRateClick = useCallback(function (event) {
    event.preventDefault();
    event.stopPropagation();

    if (mediaRef && mediaRef.current) {
      var nextRate = getNextPlaybackRate(playbackRate);
      mediaRef.current.playbackRate = nextRate;
      setPlaybackRate(nextRate);
    }
  }, [mediaRef.current, playbackRate]);
  var currentTime = useMemo(function () {
    return formatSeconds(progress || 0);
  }, [progress]);
  var endTime = useMemo(function () {
    return formatSeconds(duration || 0);
  }, [duration]);
  var progressBarWidth = useMemo(function () {
    return progress / duration * 100;
  }, [progress, duration]);
  return React.createElement(React.Fragment, null, React.createElement(MediaComponent, _extends({}, mediaProps, {
    ref: mediaRef,
    autoPlay: autoPlay,
    loop: loop,
    onTimeUpdate: onTimeUpdate,
    onPlay: function onPlay() {
      return setIsPlaying(true);
    },
    onPause: function onPause() {
      return setIsPlaying(false);
    },
    onLoadedMetadata: setInitialDuration,
    muted: muted
  })), showControls && _jsx(OuterWrap, {}, void 0, !hasInteracted ? _jsx(InnerWrap, {
    opacity: 1
  }, void 0, _jsx(PlaybackButton, {
    cardSize: cardSize,
    onClick: onPlaybackToggle
  })) : React.createElement(React.Fragment, null, _jsx(InnerWrap, {}, void 0, isNotSmall && _jsx(SeekButton, {
    className: classNames.rwControl,
    type: "rewind",
    cardSize: cardSize,
    onClick: function onClick(event) {
      return onSeekClick(event, 'rewind');
    }
  }), _jsx(PlaybackButton, {
    cardSize: cardSize,
    isPlaying: isPlaying,
    onClick: onPlaybackToggle
  }), isNotSmall && _jsx(SeekButton, {
    className: classNames.ffwControl,
    type: "fastforward",
    cardSize: cardSize,
    onClick: function onClick(event) {
      return onSeekClick(event, 'fastforward');
    }
  })), isNotSmall && _jsx(FooterControls, {
    cardSize: cardSize,
    currentTime: currentTime,
    endTime: endTime,
    isMuted: isMuted,
    onMuteClick: onMuteClick,
    onPlaybackRateClick: onPlaybackRateClick,
    playbackRate: playbackRate
  })), _jsx(ProgressBar, {
    cardSize: cardSize,
    progress: progressBarWidth
  })));
};

function _templateObject$e() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n\n  &::media-controls-start-playback-button {\n    display: none;\n    appearance: none;\n  }\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}
var VideoDOM = styled('video')(_templateObject$e());

var Video = function Video(_ref) {
  var autoPlay = _ref.autoPlay,
      hasControls = _ref.controls,
      cardSize = _ref.cardSize,
      isLoading = _ref.isLoading,
      loop = _ref.loop,
      imageUrl = _ref.imageUrl,
      muted = _ref.muted,
      playsInline = _ref.playsInline,
      videoUrl = _ref.videoUrl,
      props = _objectWithoutProperties(_ref, ["autoPlay", "controls", "cardSize", "isLoading", "loop", "imageUrl", "muted", "playsInline", "videoUrl"]);

  var mediaProps = useMemo(function () {
    var mediaProps = {
      className: "".concat(classNames.media, " ").concat(classNames.video),
      src: videoUrl,
      playsInline: playsInline
    };
    if (imageUrl) mediaProps.poster = imageProxy(imageUrl);
    return mediaProps;
  }, [imageUrl, loop, muted, playsInline, videoUrl]);
  return React.createElement(Wrap, _extends({
    className: "".concat(classNames.mediaWrapper, " ").concat(classNames.videoWrapper),
    cardSize: cardSize,
    isLoading: isLoading
  }, props), _jsx(Controls, {
    autoPlay: autoPlay,
    cardSize: cardSize,
    loop: loop,
    MediaComponent: VideoDOM,
    mediaProps: mediaProps,
    muted: muted,
    showControls: hasControls
  }));
};

var Audio = function Audio(_ref) {
  var audioUrl = _ref.audioUrl,
      autoPlay = _ref.autoPlay,
      cardSize = _ref.cardSize,
      hasControls = _ref.controls,
      imageUrl = _ref.imageUrl,
      loop = _ref.loop,
      muted = _ref.muted;
  var mediaProps = useMemo(function () {
    return {
      className: "".concat(classNames.media, " ").concat(classNames.audio),
      src: audioUrl
    };
  }, [audioUrl]);
  return _jsx(Image, {
    imageUrl: imageUrl,
    cardSize: cardSize,
    className: "".concat(classNames.mediaWrapper, " ").concat(classNames.audioWrapper)
  }, void 0, _jsx(Controls, {
    autoPlay: autoPlay,
    cardSize: cardSize,
    loop: loop,
    MediaComponent: "audio",
    mediaProps: mediaProps,
    muted: muted,
    showControls: hasControls
  }));
};

var isUrl = function isUrl(url) {
  return getUrlPath(url) !== null;
};

var MEDIA_COMPONENT = {
  video: Video,
  image: Image,
  audio: Audio
};

var getMediaType = function getMediaType(isAudio, isVideo) {
  if (isAudio) return 'audio';
  if (isVideo) return 'video';
  return 'image';
};

function CardMedia(props) {
  var imageUrl = props.imageUrl,
      isAudio = props.isAudio,
      isVideo = props.isVideo;

  var _useState = useState(!isUrl(imageUrl)),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var mediaType = getMediaType(isAudio, isVideo);
  var MediaComponent = MEDIA_COMPONENT[mediaType];
  return React.createElement(React.Fragment, null, React.createElement(MediaComponent, _extends({}, props, {
    isLoading: isLoading
  })), isLoading && _jsx(ImageLoadCatcher, {
    src: imageUrl,
    onLoad: function onLoad() {
      return setIsLoading(false);
    }
  }));
}

function _templateObject5$4() {
  var data = _taggedTemplateLiteral(["\n  flex-direction: ", ";\n"]);

  _templateObject5$4 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$6() {
  var data = _taggedTemplateLiteral(["\n  transition-property: background, border-color;\n  &:hover {\n    background: #f5f8fa;\n    border-color: rgba(136, 153, 166, 0.5);\n  }\n"]);

  _templateObject4$6 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$7() {
  var data = _taggedTemplateLiteral(["\n    height: calc(", " * 7/9);\n  "]);

  _templateObject3$7 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$b() {
  var data = _taggedTemplateLiteral(["\n  flex-direction: column;\n  height: ", ";\n  transition-property: background, border-color, height;\n\n  ", ";\n"]);

  _templateObject2$b = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$f() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-color: ", ";\n  transition-property: filter;\n\n  &&& {\n    color: ", ";\n  }\n\n  &:hover {\n    filter: brightness(90%);\n  }\n"]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}
var HEIGHT = '382px';

var contrastStyle = function contrastStyle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color;
  return css(_templateObject$f(), backgroundColor, color, color);
};

var largeStyle = css(_templateObject2$b(), HEIGHT, media.mobile(_templateObject3$7(), HEIGHT));
var hoverStyle = css(_templateObject4$6());

var rtlStyle = function rtlStyle(_ref2) {
  var cardSize = _ref2.cardSize;
  return css(_templateObject5$4(), isLarge(cardSize) ? 'column-reverse' : 'row-reverse');
};

var baseStyle = css(function () {
  return "\n  max-width: 500px;\n  background-color: #fff;\n  border-width: 1px;\n  border-style: solid;\n  border-color: #e1e8ed;\n  overflow: hidden;\n  color: #181919;\n  font-family: ".concat(font.sans, ";\n  display: flex;\n  text-decoration: none;\n  opacity: 1;\n  position: relative;\n\n  transition-duration: ").concat(speed.medium, ";\n  transition-timing-function: ").concat(animation.medium, ";\n\n\n  &:active,\n  &:hover {\n    outline: 0;\n  }\n");
});

var createEl = function createEl(el) {
  return styled(el)(baseStyle, function (_ref3) {
    var isLoading = _ref3.isLoading,
        contrast = _ref3.contrast;
    return !isLoading && !contrast && hoverStyle;
  }, function (_ref4) {
    var cardSize = _ref4.cardSize;
    return isLarge(cardSize) && largeStyle;
  }, function (_ref5) {
    var direction = _ref5.direction;
    return direction === 'rtl' && rtlStyle;
  }, function (_ref6) {
    var backgroundColor = _ref6.backgroundColor,
        color = _ref6.color,
        contrast = _ref6.contrast;
    return contrast && color && backgroundColor && contrastStyle;
  }, function (_ref7) {
    var backgroundColor = _ref7.backgroundColor,
        color = _ref7.color,
        contrast = _ref7.contrast;
    return contrast && (!color || !backgroundColor) && hoverStyle;
  });
};

var CardWrap = forwardRef(function (_ref8, ref) {
  var href = _ref8.href,
      rel = _ref8.rel,
      target = _ref8.target,
      restProps = _objectWithoutProperties(_ref8, ["href", "rel", "target"]);

  var props = _objectSpread2({}, restProps, {
    ref: ref
  });

  return createElement(createEl(props.as), props.as === 'a' ? _objectSpread2({
    href: href,
    rel: rel,
    target: target
  }, props) : props);
});
CardWrap.defaultProps = {
  as: 'a',
  rel: 'noopener noreferrer',
  target: '_blank'
};

var useIntersectionObserver = function useIntersectionObserver(enabled, options) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasIntersected = _useState2[0],
      setHasIntersected = _useState2[1];

  var refCallback = useCallback(function (node) {
    if (enabled) {
      var onIntersect = function onIntersect(_ref, self) {
        var _ref2 = _slicedToArray(_ref, 1),
            entry = _ref2[0];

        if (entry.isIntersecting) {
          setHasIntersected(true);
          self.unobserve(entry.target);
        }
      };

      var observer = new IntersectionObserver(onIntersect, options);

      if (node !== null) {
        observer.observe(node);
      }
    } else {
      setHasIntersected(true);
    }
  });
  return [hasIntersected, refCallback];
};

var Card = function Card(_ref) {
  var url = _ref.url,
      size = _ref.size,
      title = _ref.title,
      description = _ref.description,
      props = _objectWithoutProperties(_ref, ["url", "size", "title", "description"]);

  return React.createElement(React.Fragment, null, React.createElement(CardMedia, _extends({
    key: "".concat(url, "__").concat(size),
    url: url,
    cardSize: size
  }, props)), _jsx(CardContent, {
    title: title,
    description: description,
    url: url,
    cardSize: size
  }));
};

function Microlink(props) {
  var autoPlay = props.autoPlay,
      controls = props.controls,
      loop = props.loop,
      setData = props.setData,
      muted = props.muted,
      loadingProp = props.loading,
      playsInline = props.playsInline,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      size = props.size,
      lazy = props.lazy,
      mediaProp = props.media,
      restProps = _objectWithoutProperties(props, ["autoPlay", "controls", "loop", "setData", "muted", "loading", "playsInline", "className", "size", "lazy", "media"]);

  var mediaProps = castArray(mediaProp);
  var isLoadingUndefined = useMemo(function () {
    return loadingProp === undefined;
  }, [loadingProp]);

  var _useState = useState(isLoadingUndefined ? true : loadingProp),
      _useState2 = _slicedToArray(_useState, 2),
      loadingState = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      cardData = _useState4[0],
      setCardData = _useState4[1];

  var _useMemo = useMemo(function () {
    return getApiUrl(_objectSpread2({}, props, {
      media: mediaProps
    }));
  }, [props]),
      _useMemo2 = _slicedToArray(_useMemo, 2),
      apiUrl = _useMemo2[0],
      apiUrlProps = _useMemo2[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      iframeMedia = _useState6[0],
      setIframeMedia = _useState6[1];

  var isLazyEnabled = useMemo(function () {
    return isLazySupported && (lazy === true || isObject(lazy));
  }, [lazy]);
  var lazyOptions = useMemo(function () {
    return isObject(lazy) ? lazy : undefined;
  }, [lazy]);

  var _useIntersectionObser = useIntersectionObserver(isLazyEnabled, lazyOptions),
      _useIntersectionObser2 = _slicedToArray(_useIntersectionObser, 2),
      hasIntersected = _useIntersectionObser2[0],
      cardRef = _useIntersectionObser2[1];

  var canFetchData = useMemo(function () {
    return !isLazyEnabled || isLazyEnabled && hasIntersected;
  }, [isLazyEnabled, hasIntersected]);
  var fetchData = useCallback(function () {
    if (canFetchData) {
      setLoading(true);
      var fetch = isFunction(setData) ? Promise.resolve({}) : fetchFromApi(props.url, apiUrl, apiUrlProps);
      fetch.then(function (_ref2) {
        var data = _ref2.data;
        return mergeData(data);
      });
    }
  }, [apiUrl, canFetchData, setData, apiUrlProps.headers['x-api-key']]);
  var mergeData = useCallback(function (fetchData) {
    var payload = isFunction(setData) ? setData(fetchData) : _objectSpread2({}, fetchData, {}, setData);
    var title = payload.title,
        description = payload.description,
        url = payload.url,
        video = payload.video,
        audio = payload.audio,
        image = payload.image,
        logo = payload.logo,
        iframe = payload.iframe;
    var mediaFallback = image || logo || {};
    var media = mediaFallback;
    var videoUrl;
    var audioUrl;
    var isVideo = false;
    var isAudio = false;
    var preferredMedia = getPreferredMedia(payload, mediaProps);

    switch (preferredMedia) {
      case 'audio':
        isAudio = true;
        audioUrl = getUrlPath(audio);
        break;

      case 'video':
        isVideo = true;
        videoUrl = getUrlPath(video);
        break;

      case 'iframe':
        setIframeMedia(iframe);
        break;

      default:
        media = someProp(payload, mediaProps) || mediaFallback;
        break;
    }

    var imageUrl = getUrlPath(media);
    var _media = media,
        color = _media.color,
        backgroundColor = _media.background_color;
    setCardData({
      url: url,
      color: color,
      title: title,
      description: description,
      imageUrl: imageUrl,
      videoUrl: videoUrl,
      audioUrl: audioUrl,
      isVideo: isVideo,
      isAudio: isAudio,
      backgroundColor: backgroundColor
    });
    setLoading(false);
  }, [setData]);
  useEffect(fetchData, [props.url, setData, hasIntersected]);
  var title = cardData.title,
      color = cardData.color,
      backgroundColor = cardData.backgroundColor,
      url = cardData.url,
      description = cardData.description,
      imageUrl = cardData.imageUrl,
      videoUrl = cardData.videoUrl,
      audioUrl = cardData.audioUrl,
      isVideo = cardData.isVideo,
      isAudio = cardData.isAudio;
  var isLoading = isLoadingUndefined ? loadingState : loadingProp;

  if (iframeMedia) {
    if (!isSSR) {
      iframeMedia.scripts.forEach(function (attrs) {
        var hasScript = document.querySelector("script[src=\"".concat(attrs.src, "\"]"));

        if (!hasScript) {
          var script = document.createElement('script');
          Object.keys(attrs).forEach(function (key) {
            return script[key] = attrs[key];
          });
          document.body.appendChild(script);
        }
      });
    }

    return React.createElement("div", _extends({
      className: classNames.iframe,
      dangerouslySetInnerHTML: {
        __html: iframeMedia.html
      }
    }, restProps));
  }

  return React.createElement(CardWrap, _extends({
    className: "".concat(classNames.main, " ").concat(className),
    href: url,
    title: title,
    cardSize: size,
    color: color,
    backgroundColor: backgroundColor,
    isLoading: isLoading,
    ref: cardRef
  }, restProps), isLoading ? _jsx(CardEmptyState, {
    cardSize: size
  }) : _jsx(Card, {
    title: title,
    description: description,
    url: url,
    isVideo: isVideo,
    isAudio: isAudio,
    imageUrl: imageUrl,
    videoUrl: videoUrl,
    audioUrl: audioUrl,
    autoPlay: autoPlay,
    controls: controls,
    loop: loop,
    muted: muted,
    playsInline: playsInline,
    size: size
  }));
}

Microlink.defaultProps = {
  apiKey: undefined,
  autoPlay: true,
  controls: true,
  direction: 'ltr',
  lazy: true,
  loop: true,
  media: ['image', 'logo'],
  muted: true,
  playsInline: true,
  size: 'normal'
};

export default Microlink;
export { getApiUrl, imageProxy };
